import api from 'services/api';
import action from 'utils/action';
import checkError from 'utils/check-error';

export function projectGet(projectId) {
  return (dispatch) => {
    dispatch(action('PROJECT_GET_REQUEST'));

    return new Promise((resolve, reject) => {
      return api.get(`/api/projects/${projectId}?include=client`).then((payload) => {
        if (checkError(payload)) {
          dispatch(action('PROJECT_GET_FAILURE', payload.json));
          reject();
        } else {
          dispatch(action('PROJECT_GET_SUCCESS', payload.json));
          resolve(payload.json);
        }
      }).catch((payload) => {
        dispatch(action('PROJECT_GET_FAILURE', payload.json));
        reject();
      });
    });
  };
}

export function projectsCreate(data) {
  return (dispatch) => {
    dispatch(action('PROJECTS_CREATE_REQUEST'));

    return new Promise((resolve, reject) => {
      return api.post('/api/projects', data)
      .then((payload) => {
        if (checkError(payload)) {
          dispatch(action('PROJECTS_CREATE_FAILURE', payload.json));
          reject();
        } else {
          dispatch(action('PROJECTS_CREATE_SUCCESS', payload.json));
          resolve(payload.json.data);
        }
      })
      .catch((payload) => {
        dispatch(action('PROJECTS_CREATE_FAILURE', payload.json));
        reject();
      });
    });
  };
}

export function projectUpdate(projectId, data) {
  return (dispatch) => {
    dispatch(action('PROJECT_UPDATE_REQUEST'));

    return new Promise((resolve, reject) => {
      return api.put(`/api/projects/${projectId}?include=client`, data).then((payload) => {
        if (checkError(payload)) {
          dispatch(action('PROJECT_UPDATE_FAILURE', payload.json));
          reject();
        } else {
          dispatch(action('PROJECT_UPDATE_SUCCESS', payload.json));
          resolve();
        }
      }).catch((payload) => {
        dispatch(action('PROJECT_UPDATE_FAILURE', payload.json));
        reject();
      });
    });
  };
}

export function projectShare(projectId, data) {
  return (dispatch) => {
    dispatch(action('PROJECT_SHARE_REQUEST'));

    return new Promise((resolve, reject) => {
      return api.post(`/api/projects/${projectId}/share`, data).then((payload) => {
        if (checkError(payload)) {
          dispatch(action('PROJECT_SHARE_FAILURE', payload.json));
          reject();
        } else {
          dispatch(action('PROJECT_SHARE_SUCCESS', payload.json));
          resolve();
        }
      }).catch((payload) => {
        dispatch(action('PROJECT_SHARE_FAILURE', payload.json));
        reject();
      });
    });
  };
}

export function projectExport(projectId, url, filename, label) {
  return (dispatch) => {
    dispatch(action('PROJECT_EXPORT_REQUEST', { label }));

    return new Promise((resolve, reject) => {
      return api.get(`/api/projects/${projectId}/${url}&name=${filename}`).then((payload) => {
        if (checkError(payload)) {
          dispatch(action('PROJECT_EXPORT_FAILURE', payload.json));
          reject();
        } else {
          // Dispatch Success only after socket says so (see projectExportResolve() below)
          // dispatch(action('PROJECT_EXPORT_SUCCESS', payload.json));
          resolve(payload.json);
        }
      }).catch((payload) => {
        dispatch(action('PROJECT_EXPORT_FAILURE', payload.json));
        reject();
      });
    });
  };
}

export function projectExportResolve(label) {
  return (dispatch) => {
    dispatch(action('PROJECT_EXPORT_SUCCESS', { label }));
  };
}

export function projectSetSystem(data) {
  return (dispatch) => {
    dispatch(action('PROJECTS_SET_SYSTEM_REQUEST'));

    return new Promise((resolve, reject) => {
      return api.put(`/api/projects/${data.data.id}`, data)
      .then((payload) => {
        if (checkError(payload)) {
          dispatch(action('PROJECTS_SET_SYSTEM_FAILURE', payload.json));
          reject();
        } else {
          dispatch(action('PROJECTS_SET_SYSTEM_SUCCESS'));
          resolve(payload.json);
        }
      })
      .catch((payload) => {
        dispatch(action('PROJECTS_SET_SYSTEM_FAILURE', payload.json));
      });
    });
  };
}

export function projectGetProducts(projectId) {
  return (dispatch) => {
    dispatch(action('PROJECT_GET_PRODUCTS_REQUEST'));

    return new Promise((resolve, reject) => {
      return api.get(`/api/projects/${projectId}/products`).then((payload) => {
        if (checkError(payload)) {
          dispatch(action('PROJECT_GET_PRODUCTS_FAILURE', payload.json));
          reject();
        } else {
          dispatch(action('PROJECT_GET_PRODUCTS_SUCCESS', payload.json));
          resolve();
        }
      }).catch((payload) => {
        dispatch(action('PROJECT_GET_PRODUCTS_FAILURE', payload.json));
        reject();
      });
    });
  };
}

export function projectUpdateProduct(productId, data) {
  return (dispatch) => {
    dispatch(action('PROJECT_UPDATE_PRODUCT_REQUEST'));

    return new Promise((resolve, reject) => {
      return api.patch(`/api/project-products/${productId}`, data).then((payload) => {
        if (checkError(payload)) {
          dispatch(action('PROJECT_UPDATE_PRODUCT_FAILURE', payload.json));
          reject(payload.json);
        } else {
          dispatch(action('PROJECT_UPDATE_PRODUCT_SUCCESS', payload.json));
          resolve();
        }
      }).catch((payload) => {
        dispatch(action('PROJECT_UPDATE_PRODUCT_FAILURE', payload.json));
        reject(payload.json);
      });
    });
  };
}

export function projectUpdatePrice(projectId, price) {
  return (dispatch) => {
    dispatch(action('PROJECT_UPDATE_PRICE', { projectId, price }));
  };
}

export function projectGetOriginalSystem(projectId) {
  return (dispatch) => {
    dispatch(action('PROJECT_GET_ORIGINAL_SYSTEM_REQUEST'));

    return new Promise((resolve, reject) => {
      return api.get(`/api/projects/${projectId}/original_system`).then((payload) => {
        if (checkError(payload)) {
          dispatch(action('PROJECT_GET_ORIGINAL_SYSTEM_FAILURE', payload.json));
          reject(payload.json);
        } else {
          dispatch(action('PROJECT_GET_ORIGINAL_SYSTEM_SUCCESS', payload.json));
          resolve(payload.json);
        }
      }).catch((payload) => {
        dispatch(action('PROJECT_GET_ORIGINAL_SYSTEM_FAILURE', payload.json));
        reject(payload.json);
      });
    });
  };
}



// WEBPACK FOOTER //
// ./js/actions/projects.js